import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

/**
 * Shared editorial wrapper for long-form content pages (legal, about, etc.).
 * Children are plain semantic HTML (h2/h3/p/ul/li/a/strong) — styling is applied
 * via arbitrary child selectors so each page stays clean and consistent.
 */
export default function LegalLayout({ eyebrow, title, intro, lastUpdated, path, children }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="max-w-[860px] mx-auto px-4 md:px-8 py-12 md:py-20">
      {path && <Seo title={title} description={intro} path={path} />}
      <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground mb-8 transition-colors">
        <ArrowLeft className="h-4 w-4" strokeWidth={1} /> Back to home
      </Link>

      {eyebrow && <div className="text-xs uppercase tracking-[0.3em] text-primary mb-4">{eyebrow}</div>}
      <h1 className="font-serif text-4xl md:text-6xl mb-4 tracking-tight">{title}</h1>
      {intro && <p className="text-muted-foreground text-lg leading-relaxed mb-4 max-w-2xl">{intro}</p>}
      {lastUpdated && (
        <p className="text-xs uppercase tracking-widest text-muted-foreground/70 mb-10">Last updated · {lastUpdated}</p>
      )}

      <div
        className="text-muted-foreground leading-relaxed
          [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:md:text-3xl [&_h2]:text-foreground [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:tracking-tight
          [&_h3]:font-serif [&_h3]:text-xl [&_h3]:text-foreground [&_h3]:mt-8 [&_h3]:mb-3
          [&_p]:mb-4
          [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:space-y-2 [&_ul]:mb-4
          [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:space-y-2 [&_ol]:mb-4
          [&_a]:text-primary [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary/80
          [&_strong]:text-foreground [&_strong]:font-medium
          [&_hr]:border-border [&_hr]:my-10"
      >
        {children}
      </div>
    </div>
  );
}
